export const ADD_INGREDIENTS = "ADD_INGREDIENTS";
export const REMOVE_INGREDIENTS = "REMOVE_INGREDIENTS";
export const SET_INGREDIENTS = "SET_INGREDIENTS";
export const FETCH_INGREDIENTS_FAILED = "FETCH_INGREDIENTS_FAILED";

export const PURCHASE_BURGER_START = "PURCHASE_BURGER_START";
export const PURCHASE_BURGER_SUCCESS = "PURCHASE_BURGER_SUCCESS";
export const PURCHASE_BURGER_FAIL = "PURCHASE_BURGER_FAIL";

export const PURCHASE_INIT = "PURCHASE_INIT";

export const  FETCH_ORDER_START='FETCH_ORDER_START'
export const  FETCH_ORDER_SUCCESS='FETCH_ORDER_SUCCESS'
export const  FETCH_ORDER_FAILED='FETCH_ORDER_FAILED'
export const AUTH_START='AUTH_START'
export const AUTH_SUCCESS='AUTH_SUCCESS'
export const AUTH_FAILED='AUTH_FAILED'

export const LOG_OUT='LOG_OUT'

export const SET_AUTH_REDIRECT_PATH='SET_AUTH_REDIRECT_PATH'
